// Full structured content extracted from the client's Qualifi Word documents.
// Each qualification renders as an accordion item on its page.

const includedDefault = [
  "QUALIFI registration and certification",
  "Comprehensive theory tuition",
  "Practical hands-on training",
  "Live model assessments",
  "Learning resources",
  "Assessment and portfolio guidance",
  "Ongoing tutor support throughout your qualification",
  "Small class sizes for personalised learning",
];

export const QUALIFI_AESTHETICS = [
  {
    id: "l3-bls",
    level: "Level 3",
    title: "QUALIFI Level 3 Award in Basic Life Support and Management of Anaphylaxis in Clinical Practice",
    comingSoon: true,
    overview:
      "Develop the essential life-saving skills required to respond confidently and effectively during medical emergencies. This Ofqual-regulated qualification is designed for professionals working within clinical environments, including aesthetic practitioners, healthcare professionals, dental teams, pharmacy staff and those working within health, beauty and wellbeing settings. It provides the knowledge, practical skills and confidence required to recognise and respond to life-threatening emergencies including cardiac arrest, choking and anaphylaxis, and combines current Resuscitation Council UK guidance with practical, hands-on learning. It is an essential requirement for many regulated aesthetic qualifications including the Level 4 and Level 5 Aesthetic Practice programmes, and must be renewed annually.",
    learn: [
      "Assess an emergency situation safely using a structured approach.",
      "Perform a primary survey and recognise life-threatening conditions.",
      "Recognise when cardiopulmonary resuscitation (CPR) is required.",
      "Perform high-quality adult CPR using current Resuscitation Council UK guidelines.",
      "Safely use an Automated External Defibrillator (AED).",
      "Place an unconscious casualty into the recovery position and monitor their condition.",
      "Recognise the signs and symptoms of anaphylaxis and provide emergency first aid.",
      "Safely demonstrate the use of adrenaline auto-injector training devices.",
      "Recognise and manage choking emergencies.",
      "Understand infection prevention, personal safety and emergency response procedures.",
    ],
    entry: [
      "Be at least 16 years of age.",
      "Have sufficient understanding of English to complete both the practical and written assessments.",
      "Be physically capable of performing CPR on the floor as part of the practical assessment.",
      "No previous first aid qualification is required.",
    ],
    structure: [
      "1 mandatory unit",
      "1 Credit  ·  5 Total Qualification Time (TQT)  ·  4 Guided Learning Hours (GLH)",
      "Qualification Number (QAN): 610/5316/8",
      "Qualification validity: 1 year",
    ],
    units: [
      {
        code: "BLSCP301",
        title: "Basic Life Support and Management of Anaphylaxis in Clinical Practice",
        desc: "Develops the knowledge and practical competence required to assess emergency situations safely and provide appropriate first aid for life-threatening medical emergencies, including CPR, AED use, choking management, the recovery position and adrenaline auto-injector devices.",
      },
    ],
    assessment: [
      "Short Answer Question (SAQ) paper",
      "Practical observations",
      "Demonstration of CPR",
      "Safe use of an AED trainer",
      "Recovery position assessment",
      "Choking management assessment",
      "Demonstration of adrenaline auto-injector use",
      "100% pass mark required in both theory and practical. Graded Pass/Fail.",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive theory session",
      "Practical hands-on training",
      "CPR and AED practical assessment",
      "Adrenaline auto-injector training",
      "Learning resources",
      "Experienced tutor support",
      "Certificate valid for 12 months",
    ],
    progression: [
      "QUALIFI Level 4 Aesthetic Practice qualifications",
      "QUALIFI Level 5 Certificate in Aesthetic Practice",
      "QUALIFI Level 5 Advanced Diploma in Aesthetic Practice",
      "QUALIFI Level 7 Certificate in Aesthetic Practice",
      "Recognised across healthcare, dental, pharmacy and clinical settings requiring annual BLS and Anaphylaxis training.",
    ],
    why:
      "We believe emergency training should be practical, engaging and confidence-building. Our experienced trainers deliver realistic, hands-on sessions using industry-standard equipment, allowing every learner to practise life-saving skills in a supportive learning environment.",
  },
  {
    id: "l4-aesthetic",
    level: "Level 4",
    title: "QUALIFI Level 4 Certificate in Aesthetic Practice",
    comingSoon: true,
    overview:
      "Begin your journey into regulated aesthetics with this Ofqual-regulated qualification designed for qualified beauty therapists and aesthetic practitioners wishing to develop their knowledge and practical skills in advanced skin rejuvenation. It provides the essential foundations required to safely perform microneedling and superficial chemical peel treatments, while developing a comprehensive understanding of client consultation, health and safety, infection prevention, treatment planning and professional practice.",
    learn: [
      "Carry out comprehensive client consultations and treatment planning.",
      "Assess skin health and determine client suitability for treatment.",
      "Understand current legislation, health and safety, infection prevention and hygiene standards.",
      "Safely perform professional microneedling treatments.",
      "Safely perform superficial chemical peel treatments.",
      "Recognise indications, contraindications and treatment limitations.",
      "Deliver effective pre-treatment and post-treatment advice.",
      "Maintain accurate consultation records and clinical documentation.",
      "Work confidently within professional, ethical and evidence-based practice.",
    ],
    entry: [
      "Be aged 18 years or over.",
      "Hold a relevant Level 3 Beauty Therapy qualification (or equivalent).",
      "Hold the QUALIFI Level 4 Certificate in Anatomy and Physiology for Aesthetic Practice.",
      "Hold a valid First Aid at Work or equivalent Basic Life Support qualification appropriate for aesthetic practice.",
    ],
    structure: [
      "4 mandatory units",
      "35 Credits  ·  350 Total Qualification Time (TQT)  ·  210 Guided Learning Hours (GLH)",
      "Qualification Number (QAN): 610/1195/2",
    ],
    units: [
      { code: "CO401", title: "Health, Safety and Hygiene for Aesthetic Procedures", desc: "Maintain a safe clinical environment through infection prevention, risk assessment, health and safety legislation, hygiene protocols and professional working practices." },
      { code: "CO402", title: "Client Consultation for Aesthetic Procedures", desc: "Conduct professional consultations, assess client suitability, identify contraindications, obtain informed consent and create personalised treatment plans." },
      { code: "AP409", title: "Skin Rejuvenation Using Microneedling", desc: "Safely perform professional microneedling treatments, improving skin texture, stimulating collagen production and treating a variety of skin concerns." },
      { code: "AP410", title: "Skin Rejuvenation Using Superficial Chemical Peels", desc: "Safely perform superficial chemical peel treatments, client assessment, treatment planning, product selection, application techniques and aftercare." },
    ],
    assessment: [
      "Practical observations",
      "Multiple Choice Questions (MCQs)",
      "Short Answer Questions (SAQs)",
      "Written assignments",
      "Oral questioning",
      "Practical treatment assessments",
      "Portfolio of evidence",
      "Clinical case studies",
      "Internally assessed then externally quality assured by QUALIFI. Graded Pass/Fail.",
    ],
    included: includedDefault,
    progression: [
      "QUALIFI Level 5 Certificate in Aesthetic Practice",
      "Advanced skin rejuvenation qualifications",
      "Employment within advanced beauty and aesthetic practice",
      "Further regulated education within the aesthetics industry",
    ],
    why:
      "We combine evidence-based theory with practical clinical training, giving every learner the confidence and competence to deliver safe, effective aesthetic treatments while working within current industry standards and legislation.",
  },
  {
    id: "l5-aesthetic",
    level: "Level 5",
    title: "QUALIFI Level 5 Certificate in Aesthetic Practice",
    comingSoon: true,
    overview:
      "Take the next step in your aesthetics career with this Ofqual-regulated qualification designed for experienced aesthetic practitioners looking to advance their clinical knowledge, professional practice and understanding of advanced skin rejuvenation treatments. Developed to strengthen your understanding of aesthetic practice through advanced study of skin science, professional standards, legal and regulatory responsibilities, collaborative working and advanced skin rejuvenation procedures.",
    learn: [
      "Understand the legal and regulatory framework governing aesthetic practice.",
      "Apply professional, ethical and evidence-based principles to clinical decision making.",
      "Develop advanced understanding of facial anatomy, physiology and the ageing process.",
      "Understand advanced skin rejuvenation procedures including microneedling and chemical peels.",
      "Work collaboratively with healthcare professionals and understand referral pathways.",
      "Apply effective communication within multidisciplinary clinical environments.",
      "Develop critical thinking, analytical and problem-solving skills.",
      "Strengthen consultation techniques and client safety throughout the treatment journey.",
      "Understand professional responsibilities, insurance requirements and ongoing CPD.",
    ],
    entry: [
      "Be at least 18 years of age.",
      "Hold a relevant regulated Level 4 qualification (e.g. QUALIFI L4 Diploma in Aesthetic Procedures for Skin Rejuvenation; QUALIFI L4 Certificate in Aesthetic Practice; QUALIFI L4 Certificate in Micropigmentation; QUALIFI L4 Certificate in Laser, Light and Energy-Based Procedures; or equivalent).",
      "Hold a current Basic Life Support (BLS) and Anaphylaxis Management qualification.",
      "Successfully complete an enrolment interview to determine suitability for the programme.",
    ],
    structure: [
      "5 mandatory units, includes units at Level 5, Level 6 and Level 7",
      "17 Credits  ·  158 Total Qualification Time (TQT)  ·  88 Guided Learning Hours (GLH)",
    ],
    units: [
      { code: "AP501", title: "Legal and Regulatory Requirements in Aesthetic Practice", desc: "UK legislation, regulatory bodies, infection prevention, health and safety, aesthetic medicines and risk management." },
      { code: "AP502", title: "Professional Standards within Aesthetic Practice", desc: "Professional standards, ethics, insurance, advertising regulations, complaint management and CPD." },
      { code: "AP503", title: "Working Collaboratively with Healthcare Professionals", desc: "Multidisciplinary working, referral pathways, effective communication, equality and diversity." },
      { code: "AP601", title: "Anatomy, Physiology and Morphology of the Ageing Face", desc: "Advanced knowledge of facial anatomy, physiology, tissue ageing and morphological changes." },
      { code: "AP5701", title: "Skin Micro-needling and Chemical Peels", desc: "Advanced microneedling and chemical peel procedures, assessment, planning and safe clinical practice." },
    ],
    assessment: [
      "Written assignments",
      "Short Answer Questions (SAQs)",
      "Practical observations",
      "Consultation plans",
      "Treatment and procedure records",
      "Oral questioning",
      "Minimum 65% pass mark per assessment.",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive theory delivery",
      "Practical training and live demonstrations",
      "Tutor support throughout your qualification",
      "Learning resources and assessment feedback",
      "Ongoing support following course completion",
    ],
    progression: [
      "QUALIFI Level 7 Diploma in Aesthetic Practice",
      "Advanced aesthetic practice",
      "Employment within the aesthetics industry",
      "Further professional development and specialist aesthetic training",
    ],
    why:
      "Education is about more than gaining a qualification. Our programmes are delivered by experienced Advanced Aesthetics Practitioners, Educators and Assessors who continue to work within clinical practice, teaching that reflects current industry standards.",
  },
  {
    id: "l7-clinical",
    level: "Level 7",
    title: "QUALIFI Level 7 Diploma in Clinical Aesthetic Practice",
    comingSoon: true,
    overview:
      "Advance your clinical expertise with this Ofqual-regulated advanced qualification designed for experienced aesthetic practitioners and regulated healthcare professionals wishing to develop specialist knowledge and practical competence in facial injectable treatments. Provides comprehensive education in advanced facial anatomy, dermatology, pathophysiology, complication management and psychological assessment, alongside practical training in Botulinum Toxin and Temporary Dermal Fillers for facial rejuvenation.",
    learn: [
      "Apply advanced dermatology, anatomy and pathophysiology to clinical aesthetic practice.",
      "Assess facial anatomy, musculature, vascular structures and ageing processes.",
      "Recognise anatomical danger zones and minimise clinical risk during injectable procedures.",
      "Safely manage complications associated with non-surgical cosmetic procedures.",
      "Recognise Body Dysmorphic Disorder (BDD) and apply Psychological First Aid principles.",
      "Carry out comprehensive consultations, facial assessment and personalised treatment planning.",
      "Safely administer Botulinum Toxin treatments for the face.",
      "Safely perform temporary dermal filler procedures for facial rejuvenation.",
      "Provide appropriate aftercare, post-treatment review and ongoing clinical evaluation.",
      "Apply current legislation, professional standards and evidence-based practice.",
    ],
    entry: [
      "Aged 20 years or over.",
      "Hold a QUALIFI Level 5 or Level 6 Certificate or Diploma in Aesthetic Practice (or equivalent regulated qualification) including at least one Level 6 unit, OR, a Level 6 degree (or equivalent) as a regulated healthcare professional with appropriate knowledge of skin science and anatomy.",
      "Hold a current Basic Life Support (BLS) and Anaphylaxis Management qualification (unless exempt as a regulated healthcare professional through ongoing CPD).",
      "Successfully complete an enrolment interview.",
    ],
    structure: [
      "5 mandatory units",
      "42 Credits  ·  420 Total Qualification Time (TQT)  ·  216 Guided Learning Hours (GLH)",
      "Qualification Number (QAN): 610/7007/5",
    ],
    units: [
      { code: "CO701", title: "Dermatology, Anatomy and Pathophysiology for Clinical Aesthetic Practice", desc: "Advanced understanding of facial anatomy, dermatology, musculature, vascular anatomy and the ageing process, including identification of anatomical risk zones." },
      { code: "CO602", title: "Complication Management for Aesthetic Practice", desc: "Recognise, manage and respond appropriately to complications associated with non-surgical cosmetic procedures." },
      { code: "CO507", title: "Body Dysmorphia Disorder and Psychological First Aid", desc: "BDD, informed consent, safeguarding, psychological wellbeing and referral pathways in aesthetic practice." },
      { code: "AP707", title: "Clinical Aesthetic Procedures: Botulinum Toxin Injections for the Face", desc: "Assess, plan and perform Botulinum Toxin treatments for facial rejuvenation." },
      { code: "AP708", title: "Clinical Aesthetic Procedures: Temporary Dermal Fillers for the Face", desc: "Facial dermal filler procedures, patient assessment, facial analysis, treatment planning and injection techniques." },
    ],
    assessment: [
      "Practical observations",
      "Knowledge assessments",
      "Professional discussions",
      "Clinical case studies",
      "Practical treatment assessments",
      "Portfolio of evidence",
      "Reflective practice",
      "Internally assessed then externally quality assured by QUALIFI. Graded Pass/Fail.",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive theory tuition",
      "Advanced practical Botulinum Toxin training",
      "Advanced practical dermal filler training",
      "Clinical demonstrations and live model assessments",
      "Learning resources and portfolio guidance",
      "Ongoing tutor support throughout your qualification",
      "Small class sizes for personalised learning",
    ],
    progression: [
      "QUALIFI Level 7 Award in Clinical Aesthetic Procedures: Poly-L-Lactic Acid (PLLA) Dermal Fillers",
      "QUALIFI Level 7 Award in Clinical Aesthetic Procedures: Ultrasound-Guided Dermal Fillers",
      "Advanced clinical aesthetic practice",
      "Employment within advanced aesthetic medicine and regulated clinical environments",
    ],
    why:
      "Advanced aesthetics education should develop far more than technical ability. Our programmes are delivered by experienced Advanced Aesthetics Practitioners, Educators and Assessors who continue to work within clinical practice, with a strong emphasis on patient safety, ethical practice and clinical excellence.",
  },
];

export const QUALIFI_EDUCATION = [
  {
    id: "aet",
    level: "Level 3",
    title: "QUALIFI Level 3 Award in Education and Training (AET)",
    comingSoon: true,
    overview:
      "Begin your teaching journey with the recognised introductory teaching qualification for individuals wishing to teach or train within further education, adult learning, workplace training and vocational education. Whether you're experienced and looking to share your expertise or taking your first step into education, this qualification provides the knowledge, practical skills and confidence required to plan, deliver and evaluate effective learning.",
    learn: [
      "Understand the roles, responsibilities and professional boundaries of a teacher.",
      "Plan engaging and inclusive learning sessions.",
      "Deliver effective teaching using a variety of teaching methods.",
      "Adapt teaching approaches to meet individual learner needs.",
      "Create safe, supportive and inclusive learning environments.",
      "Understand equality, diversity and safeguarding within education.",
      "Provide constructive feedback and evaluate teaching effectiveness.",
      "Understand assessment methods and the principles of learner assessment.",
      "Reflect on your own teaching practice to support continuous CPD.",
    ],
    entry: [
      "Aged 19 years or over.",
      "Successfully complete an enrolment interview.",
      "No formal teaching experience or prior qualifications required.",
      "An initial assessment of English, maths and ICT skills will be completed before the course begins.",
    ],
    structure: [
      "Level 3 Qualification",
      "12 Credits  ·  120 Total Qualification Time (TQT)  ·  81 Guided Learning Hours (GLH)",
      "Qualification Number (QAN): 603/5680/7",
    ],
    units: [
      { code: "Mandatory", title: "Understanding Roles, Responsibilities and Relationships in Education and Training", desc: "The teaching role, professional responsibilities, legislation, equality, diversity, safeguarding and creating safe, supportive learning environments." },
      { code: "Optional Teaching", title: "Understanding and Using Inclusive Teaching and Learning Approaches", desc: "Plan, deliver and evaluate engaging learning sessions using inclusive teaching methods, effective communication and reflective practice." },
      { code: "Optional Teaching", title: "Facilitate Learning and Development for Individuals", desc: "Support and facilitate learning on an individual basis within workplace or vocational settings." },
      { code: "Optional Teaching", title: "Facilitate Learning and Development in Groups", desc: "Effectively plan, deliver and evaluate learning for groups using learner-centred teaching approaches." },
      { code: "Optional Assessment", title: "Understanding Assessment in Education and Training OR Principles and Practices of Assessment", desc: "Principles of learner assessment, assessment methods, quality assurance and good assessment practice." },
    ],
    assessment: [
      "Written assignments",
      "Portfolio of evidence",
      "Practical teaching observation",
      "Micro-teaching session, minimum one 15-minute observed session as part of one hour of micro-teaching activity",
      "Professional discussion where appropriate",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive learning materials",
      "Tutor-led classroom teaching",
      "Practical teaching activities",
      "Teaching observation and feedback",
      "Portfolio guidance and assessment support",
      "Ongoing tutor support",
      "Small class sizes",
    ],
    progression: [
      "QUALIFI Level 4 qualifications",
      "QUALIFI Level 4 Certificate in Education and Training",
      "Teaching and training roles within further education, adult education and workplace learning",
      "Progression towards assessor and internal quality assurance qualifications",
    ],
    why:
      "Great educators inspire confident professionals. Our education qualifications are delivered by experienced teachers, assessors and industry practitioners who understand the realities of vocational education.",
  },
  {
    id: "cava",
    level: "Level 3",
    title: "QUALIFI Level 3 Certificate in Assessing Vocational Achievement (CAVA)",
    comingSoon: true,
    overview:
      "Develop the knowledge, practical skills and confidence to become a qualified vocational assessor. Designed for individuals who assess occupational competence in the workplace, vocational skills within training environments, or those looking to begin a career in assessment. Combines underpinning theory with practical assessment experience so you can plan, carry out and quality assure fair, valid and reliable assessments across a variety of vocational settings.",
    learn: [
      "Understand the principles and practices of assessment.",
      "Plan and carry out fair, valid and reliable assessments.",
      "Assess occupational competence within the workplace.",
      "Assess vocational knowledge and practical skills in training environments.",
      "Apply a range of assessment methods appropriate to different learners.",
      "Provide constructive feedback that supports learner development.",
      "Maintain accurate assessment records and documentation.",
      "Understand quality assurance processes and standardisation.",
      "Apply legal, ethical and regulatory requirements within assessment practice.",
    ],
    entry: [
      "Aged 19 years or over.",
      "Successfully complete an enrolment interview.",
      "Have access to learners whom they can assess in order to complete the practical assessment units.",
      "Be occupationally competent within the subject area they intend to assess.",
    ],
    structure: [
      "Level 3 Qualification",
      "15 Credits  ·  3 Mandatory Units",
      "Practical assessment in both workplace and vocational learning environments",
      "Qualification Number (QAN): 603/5650/9",
    ],
    units: [
      { code: "Unit 1", title: "Understanding the Principles and Practices of Assessment", desc: "Assessment principles, legislation, quality assurance, assessment planning, feedback, equality, diversity and professional responsibilities." },
      { code: "Unit 2", title: "Assessing Occupational Competence in the Work Environment", desc: "Assess learners carrying out their job role using observation, professional discussion, witness testimony and naturally occurring evidence." },
      { code: "Unit 3", title: "Assessing Vocational Skills, Knowledge and Understanding", desc: "Assess learners within classroom, workshop or training environments using questioning, assignments, projects and practical activities." },
    ],
    assessment: [
      "Written assignments",
      "Portfolio of evidence",
      "Practical assessment activities",
      "Direct observations",
      "Professional discussions",
      "Learner evidence and documentation",
      "Workplace and vocational assessment practice",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive learning materials",
      "Tutor-led teaching sessions",
      "Individual tutor support",
      "Assessment planning and portfolio guidance",
      "Observation and assessment feedback",
      "Small class sizes",
      "Ongoing support throughout your qualification",
    ],
    progression: [
      "Vocational Assessor roles",
      "Workplace Assessor positions",
      "Further Education assessment roles",
      "Independent training providers and apprenticeship assessment",
      "Progression to Level 4 Internal Quality Assurance (IQA) qualifications",
    ],
    why:
      "Great assessors do more than judge competence, they support, encourage and develop learners. Our experienced tutors combine industry expertise with educational excellence, delivering practical, engaging training in small groups.",
  },
  {
    id: "iqa",
    level: "Level 4",
    title: "QUALIFI Level 4 Award in the Internal Quality Assurance of Assessment Processes and Practice (IQA)",
    comingSoon: true,
    overview:
      "Designed for experienced assessors who wish to develop the knowledge, skills and practical competence required to internally quality assure assessment decisions within education, training and vocational learning environments. Prepares learners to monitor assessment practice, support and develop assessors, maintain assessment standards and ensure assessment decisions are fair, valid, reliable and consistent.",
    learn: [
      "Understand the principles and practices of internal quality assurance.",
      "Plan and implement effective internal quality assurance activities.",
      "Develop appropriate sampling strategies.",
      "Monitor assessor performance and assessment decisions.",
      "Provide constructive feedback and professional support to assessors.",
      "Standardise assessment practice to ensure consistency.",
      "Maintain quality assurance records and documentation.",
      "Apply current legislation, regulatory requirements and awarding organisation guidance.",
      "Promote continuous improvement through reflective practice and CPD.",
    ],
    entry: [
      "Aged 19 years or over.",
      "Successfully complete an enrolment interview.",
      "Be occupationally competent within the subject area in which they intend to quality assure.",
      "Have access to assessors and learner evidence to complete practical quality assurance activities.",
      "Learners will normally already hold an assessor qualification and have assessment experience.",
    ],
    structure: [
      "Level 4 Qualification",
      "12 Credits  ·  120 Total Qualification Time (TQT)  ·  90 Guided Learning Hours (GLH)",
      "Qualification Number (QAN): 603/5651/0",
    ],
    units: [
      { code: "Unit 1 (A/618/0284)", title: "Understanding the Principles and Practices of Internally Assuring the Quality of Assessment", desc: "Principles of IQA, planning, sampling, supporting assessors, consistency, regulatory requirements, standardisation and continuous quality improvement." },
      { code: "Unit 2 (F/618/0285)", title: "Internally Assure the Quality of Assessment", desc: "Carry out IQA activities in your own organisation, monitor assessor performance, sample decisions, provide feedback, complete documentation and maintain standards." },
    ],
    assessment: [
      "Written assignments",
      "Portfolio of evidence",
      "Practical quality assurance activities",
      "Sampling of assessment decisions",
      "Observation of internal quality assurance practice",
      "Professional discussions and quality assurance documentation",
      "Internally assessed then externally quality assured by QUALIFI. Graded Pass/Fail.",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive learning materials",
      "Tutor-led teaching sessions",
      "Practical IQA activities",
      "Portfolio guidance and individual tutor support",
      "Assessment feedback",
      "Small class sizes and ongoing support",
    ],
    progression: [
      "Internal Quality Assurer (IQA) roles",
      "Internal Verifier positions",
      "Quality assurance roles within colleges, academies and training providers",
      "Supporting and developing assessors within vocational education",
    ],
    why:
      "Quality assurance plays a vital role in maintaining high standards of education and assessment. Our experienced tutors combine vocational knowledge with educational expertise to help learners develop the confidence and competence required to support assessors and maintain consistent assessment standards.",
  },
  {
    id: "det",
    level: "Level 5",
    title: "QUALIFI Level 5 Diploma in Education and Training (DET)",
    comingSoon: true,
    overview:
      "Become a fully qualified teacher within the further education and skills sector with this advanced teaching qualification. Designed for individuals currently teaching, or aspiring to teach, within further education, adult education, vocational training or workplace learning. Provides the knowledge, practical teaching experience and professional skills required to confidently plan, deliver and evaluate high-quality education. Supports progression towards Qualified Teacher Learning and Skills (QTLS) status.",
    learn: [
      "Apply educational theories, principles and models to professional teaching practice.",
      "Plan, deliver and evaluate inclusive teaching and learning.",
      "Design effective assessment strategies to support learner achievement.",
      "Create engaging learning environments that promote participation and progression.",
      "Develop curriculum plans and learning resources within your specialist subject.",
      "Reflect critically on your own teaching practice to continually improve performance.",
      "Understand professionalism, quality assurance and accountability within education.",
      "Conduct action research to enhance teaching and learner outcomes.",
      "Support equality, diversity and inclusive practice.",
    ],
    entry: [
      "Aged 19 years or over.",
      "Successfully complete an enrolment interview.",
      "Be qualified and/or experienced within the subject you intend to teach.",
      "Demonstrate the academic ability to study at Level 5.",
      "Have access to a suitable teaching placement to complete the required teaching practice.",
    ],
    structure: [
      "Level 5 Qualification  ·  120 Credits",
      "Minimum 100 Hours Teaching Practice",
      "Minimum 8 Assessed Teaching Observations",
      "Qualification Number (QAN): 603/6055/0",
    ],
    units: [
      { code: "Mandatory", title: "Theories, Principles and Models in Education and Training", desc: "Educational theory, learning models, communication, curriculum design, assessment and reflective practice." },
      { code: "Mandatory", title: "Teaching, Learning and Assessment in Education and Training", desc: "Plan, deliver and assess inclusive learning programmes using effective teaching strategies, learner assessment and classroom management." },
      { code: "Mandatory", title: "Developing Teaching, Learning and Assessment", desc: "Critically evaluate and improve teaching, learning and assessment through reflective practice and CPD." },
      { code: "Mandatory", title: "Professional Practice in Education and Training", desc: "Professional behaviours, accountability, quality improvement and the wider responsibilities of educators." },
      { code: "Optional", title: "Optional Units", desc: "Includes Action Research; Develop and Prepare Resources for Learning and Development; Developing, Using and Organising Resources in a Specialist Area; Equality and Diversity; Inclusive Practice; Internally Assure the Quality of Assessment; Manage Learning and Development in Groups." },
    ],
    assessment: [
      "Written assignments",
      "Portfolio of evidence",
      "Professional teaching practice",
      "Lesson planning and resource development",
      "Reflective evaluations",
      "Practical teaching observations",
      "Minimum 100 hours of teaching practice with at least 8 assessed observations.",
    ],
    included: [
      "QUALIFI registration and certification",
      "Comprehensive learning materials",
      "Tutor-led teaching sessions",
      "Individual tutor support",
      "Teaching observations and professional feedback",
      "Portfolio guidance and assessment support",
      "Small class sizes and ongoing support",
    ],
    progression: [
      "Teaching roles within further education colleges",
      "Adult and community education",
      "Independent training providers",
      "Workplace and vocational education",
      "Progression towards Qualified Teacher Learning and Skills (QTLS)",
      "Further study at Level 6 or undergraduate degree level",
    ],
    why:
      "We are passionate about developing knowledgeable, confident and reflective educators. Our education qualifications are delivered by experienced teachers, assessors and vocational professionals who understand the realities of modern teaching.",
  },
];
